import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type AssetPerformanceLineDataDashboard } from '../services/getAssetPerformanceRegisterData'

export interface AssetPerformanceDataState {
  isLoading: boolean
  errorMessage: string | null
  AssetPerformanceData: AssetPerformanceLineDataDashboard | null
  httpStatus: number | null
}

// Initial state of the slice

const initialState: AssetPerformanceDataState = {
  AssetPerformanceData: null,
  isLoading: false,
  errorMessage: null,
  httpStatus: null
}

// Slice to return from action
export const AssetPerformanceGraphDataState = createSlice({
  name: 'AssetPerformanceGraphData',
  initialState,
  reducers: {
    AssetPerformanceDataLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        AssetPerformanceData: null,
        isLoading: true,
        errorMessage: null,
        httpStatus: 0
      }
    },
    AssetPerformanceDataUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        AssetPerformanceData: action.payload.data,
        isLoading: false,
        errorMessage: null,
        httpStatus: action.payload.httpStatus
      }
    },
    AssetPerformanceDataErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        AssetPerformanceData: null,
        isLoading: false,
        errorMessage: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

// Actions to export
export const {
  AssetPerformanceDataLoadingAction,
  AssetPerformanceDataUpdateAction,
  AssetPerformanceDataErrorAction
} = AssetPerformanceGraphDataState.actions

export default AssetPerformanceGraphDataState.reducer
